import { useEffect, useRef, useState } from "react";

export const CustomCursor = () => {
  const ringRef = useRef(null);
  const dotRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    const pos = { x: -100, y: -100 };
    const ring = { x: -100, y: -100 };
    let hovering = false;
    let raf;

    const onMove = (e) => {
      pos.x = e.clientX;
      pos.y = e.clientY;
      const t = e.target;
      hovering = !!t.closest("a, button, [role='button'], input, textarea, select, [data-cursor]");
    };
    const loop = () => {
      ring.x += (pos.x - ring.x) * 0.16;
      ring.y += (pos.y - ring.y) * 0.16;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ring.x}px, ${ring.y}px) translate(-50%, -50%) scale(${hovering ? 1.9 : 1})`;
        ringRef.current.style.borderColor = hovering ? "#D9C29C" : "#A9875F";
      }
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%)`;
      }
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("mousemove", onMove, { passive: true });
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  if (!enabled) return null;
  return (
    <>
      <div
        ref={ringRef}
        data-testid="custom-cursor-ring"
        className="fixed top-0 left-0 z-[100] w-8 h-8 rounded-full border border-gold pointer-events-none transition-[border-color] duration-200 will-change-transform"
        aria-hidden="true"
      />
      <div
        ref={dotRef}
        className="fixed top-0 left-0 z-[100] w-1.5 h-1.5 rounded-full bg-gold pointer-events-none will-change-transform"
        aria-hidden="true"
      />
    </>
  );
};
